module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    staticClass: "box",
    style: (_vm.styleObject)
  }, [_h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.x3,
      opacity: _vm.opacity
    })
  }), " ", _h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.y3,
      opacity: _vm.opacity
    })
  }), " ", _h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.z1,
      opacity: _vm.opacity
    })
  }), " ", _h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.y1,
      opacity: _vm.opacity
    })
  }), " ", _h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.z3,
      opacity: _vm.opacity
    })
  }), " ", _h('div', {
    staticClass: "face",
    style: ({
      background: _vm.color.x1,
      opacity: _vm.opacity
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-381f3786!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cube.vue
// module id = 52
// module chunks = 2